/**
 * OFAC + EU consolidated sanctions list - country ISO 3166-1 alpha-2 codes.
 *
 * Russia (RU) is included as a blanket block for new signups.  Partial
 * sanctions (Crimea / Donetsk / Luhansk) make region-level filtering
 * impractical on the client side, so we block all RU signups and direct
 * affected users to support for manual review.
 *
 * Consumed by:
 *   - Backend `sanctions-guard` middleware (extends with Crimea region check)
 *   - Frontend signup page (geo-based notice)
 */
export const SANCTIONED_COUNTRIES = new Set([
  'CU', // Cuba
  'IR', // Iran
  'KP', // North Korea
  'SY', // Syria
  'RU', // Russia (partial - Crimea, Donetsk, Luhansk; blanket-blocked for signup safety)
] as const)

/** TLD blocklist for sanctioned jurisdictions (email domain check). */
export const BLOCKED_TLDS = new Set([
  '.cu',
  '.ir',
  '.kp',
  '.sy',
] as const)

/**
 * Returns `true` when the given ISO country code belongs to a sanctioned
 * jurisdiction.  Case-insensitive.  Returns `false` for null / undefined /
 * empty input (fail-open for local dev where no country header is present).
 */
export function isBlockedCountry(countryCode: string | null | undefined): boolean {
  if (!countryCode) return false
  return SANCTIONED_COUNTRIES.has(countryCode.toUpperCase() as any)
}

/**
 * Returns `true` when the email address ends with a TLD that maps to a
 * sanctioned jurisdiction.  Case-insensitive.
 */
export function isBlockedEmailTld(email: string): boolean {
  const lower = email.toLowerCase()
  for (const tld of BLOCKED_TLDS) {
    if (lower.endsWith(tld)) return true
  }
  return false
}
